import React from 'react';
import assign from 'object-assign';

import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import DatePicker from '../Common/DatePicker';
import SelectField from '../Common/SelectField';
import { Card, CardText } from 'material-ui/Card';
import MenuItem from 'material-ui/MenuItem';

import SkillActions from '../../actions/SkillActionCreator';
import SkillStore from '../../stores/SkillStore';

import CertificateActions from '../../actions/CertificateActionCreator';
import CertificateStore from '../../stores/CertificateStore';


const SkillForm = React.createClass({

    getInitialState: function () {
        const defaultDate = new Date();
        return {
            isEdit: (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/)),
            details: {
                id: '',
                name: '',
                description: '',
                criteria: '',
                validFrom: defaultDate,
                validTo: null,
                lifetime: '',
                listOrder: '',
                status: '',
                type: 'knowledge',
                level: 'entry level',
                group: '',
                trainer:0,
                code: '',
                certificate: '',
                certificateId: 0,
                sysStatus: ''
            },
            defaultDate,
            certificates: [],
            dropdowns: {
                levelOptions: [],
                typeOptions: [],
                groupOptions: [],
                trainerOptions: [
                    {id: 0, name: 'standard'},
                    {id: 1, name: 'trainer'}
                ],
            }
        }
    },

    componentDidMount: function() {
        this.listeners = [
            SkillStore.addListener(this.onChange),
            CertificateStore.addListener(this.onCertificateChange.bind(this)),
        ];
        SkillActions.getLevelOptions();
        SkillActions.getTypeOptions();
        SkillActions.getGroupOptions();

        CertificateActions.getAll();

        if(this.state.isEdit) {
            SkillActions.getById(this.props.routeParams.id);
        }
    },

    componentWillUnmount: function() {
        this.listeners.forEach(listener => listener.remove());
    },

    render: function () {

        const formTitle  = (!this.state.isEdit ? 'New Skill' : this.state.details.name);

        // transform to Date object
        const validFrom = (this.state.details.validFrom && new Date(this.state.details.validFrom));
        const validTo = (this.state.details.validTo && new Date(this.state.details.validTo));

        return(
            <Form
                title={formTitle}
                onSave={this.onSave}
                redirectTo={false}
            >
                <Card className="cent-card">
                    <CardText>
                        <div className='cent-flex-row'>
                            <div className='cent-col-1'>
                                <TextField
                                    name="name"
                                    value={this.state.details.name}
                                    validations="minLength:2,maxLength:60"
                                    validationError="Please use only letters, at least 2"
                                    hintText="Name"
                                    floatingLabelText="Name"
                                    required
                                />
                            </div>
                            <div className='cent-col-1'>
                                <TextField
                                    name="code"
                                    validations="minLength:2,maxLength:16"
                                    validationError="Maximum length of 16 characters"
                                    value={this.state.details.code}
                                    hintText="Code"
                                    floatingLabelText="Code"
                                    required
                                />
                            </div>
                            <div className='cent-col-1'>
                                <TextField
                                    name="description"
                                    validations="minLength:2,maxLength:400"
                                    validationError="Please use only letters, at least 2"
                                    multiLine={true}
                                    rowsMax={8}
                                    value={this.state.details.description}
                                    hintText="Description"
                                    floatingLabelText="Description"
                                />
                            </div>
                            <div className='cent-col-1'>
                                <TextField
                                name="criteria"
                                validations="minLength:2,maxLength:255"
                                validationError="Please use only letters, at least 2"
                                multiLine={true}
                                rowsMax={8}
                                value={this.state.details.criteria}
                                hintText="Criteria"
                                floatingLabelText="Criteria"
                            />
                            </div>
                            <div className='cent-col-2'>
                                <DatePicker
                                name="validFrom"
                                defaultDate={this.state.defaultDate}
                                value={validFrom}
                                maxDate={validTo}
                                hintText="Available from"
                                floatingLabelText="Available from"
                                onChange={this._onValidFromChange}
                                required
                                />
                            </div>
                            <div className='cent-col-2'>
                                <DatePicker
                                    name="validTo"
                                    minDate={validFrom}
                                    value={validTo}
                                    hintText="Available to"
                                    floatingLabelText="Available to"
                                    onChange={this._onValidToChange}
                                />
                            </div>
                            <div className='cent-col-2'>
                                <TextField
                                    name="lifetime"
                                    value={this.state.details.lifetime}
                                    validations="isNumeric"
                                    validationError="Only use numbers"
                                    hintText="Lifetime (days)"
                                    floatingLabelText="Lifetime (days)"
                                />
                            </div>
                            <div className='cent-col-2'>
                                <SelectField
                                    name="type"
                                    floatingLabelText="Type"
                                    value={this.state.details.type}
                                    autoWidth={true}
                                >
                                    {this.state.dropdowns.typeOptions.map(function(type) {
                                        return (
                                           <MenuItem
                                                key={type.id}
                                                value={type.name}
                                                primaryText={type.name}
                                            />
                                        )
                                    })}
                                </SelectField>
                            </div>
                            <div className='cent-col-2'>
                                <SelectField
                                    name="level"
                                    floatingLabelText="Level"
                                    value={this.state.details.level}
                                    autoWidth={true}
                                >
                                    {this.state.dropdowns.levelOptions.map(function(level) {
                                        return (
                                           <MenuItem
                                                key={level.id}
                                                value={level.name}
                                                primaryText={level.name}
                                            />
                                        )
                                    })}
                                </SelectField>
                            </div>
                            <div className='cent-col-2'>
                                <SelectField
                                    name="trainer"
                                    floatingLabelText="Scope"
                                    value={this.state.details.trainer}
                                    autoWidth={true}
                                >
                                    {this.state.dropdowns.trainerOptions.map(function(trainer) {
                                        return (
                                           <MenuItem
                                                key={trainer.id}
                                                value={trainer.id}
                                                primaryText={trainer.name}
                                            />
                                        )
                                    })}
                                </SelectField>
                            </div>
                            <div className='cent-col-2'>
                                <SelectField
                                    name="certificateId"
                                    floatingLabelText="Certificate"
                                    value={this.state.details.certificateId}
                                    autoWidth={true}
                                >
                                    <MenuItem key={0} value={0} primaryText="None" />
                                    {this.state.certificates.map(function(certificate) {
                                        return (
                                            <MenuItem
                                                key={certificate.id}
                                                value={certificate.id}
                                                primaryText={certificate.name}
                                            />
                                        )
                                    })}
                                </SelectField>
                            </div>
                            <div className='cent-col-2'>
                                <SelectField
                                    name="group"
                                    floatingLabelText="Group"
                                    value={this.state.details.group}
                                    autoWidth={true}
                                >
                                    {this.state.dropdowns.groupOptions.map(function(group) {
                                        return (
                                            <MenuItem
                                                key={group.id}
                                                value={group.name}
                                                primaryText={group.name}
                                            />
                                        )
                                    })}
                                </SelectField>
                            </div>
                        </div>
                    </CardText>
                </Card>
            </Form>
      );
    },

    onChange: function() {
        let changes = {
            dropdowns: {
                ...this.state.dropdowns,
                levelOptions: SkillStore.getLevelOptions(),
                typeOptions:  SkillStore.getTypeOptions(),
                groupOptions: SkillStore.getGroupOptions()
            }
        };
        if (this.state.isEdit) {
            const skill = SkillStore.getById(this.props.routeParams.id);
            if (!!skill) {
                changes.details = skill;
            }
        }

        this.setState(changes);
    },

    onSave: function (model) {
        if(!this.state.isEdit) {
            return SkillActions.save(model);
        } else {
            return SkillActions.update(this.props.routeParams.id, model);
        }
    },

    _onValidFromChange: function(e, value) {
        const details = assign({}, this.state.details, {validFrom: value && new Date(value)});
        this.setState(assign({}, this.state, {details: details }));
    },

    _onValidToChange: function(e, value) {
        const details = assign({}, this.state.details, {validTo: value && new Date(value)});
        this.setState(assign({}, this.state, {details: details }));
    },

    onCertificateChange: function() {
        if (CertificateStore.isFetching()) { return; } // guard
        const certificates = CertificateStore.getAll();
        if (!!certificates) {
            this.setState({certificates});
        }
    }

});

export default SkillForm;
